import React, { useCallback, useState } from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { FaStore } from 'react-icons/fa';
import { SiIfood } from 'react-icons/si';
import { MdTimer, MdAttachMoney, MdMoneyOff, MdMoped } from 'react-icons/md';

import {
  Container,
  Content,
  Header,
  OrderContent,
  Venda,
  Entrega,
  Cliente,
  Entregador,
  Obs,
  Valores,
} from './styles';

type EntregaData = {
  id_entrega: number;
  id_loja: number;
  id_venda: number;
  id_entregador: number;
  nome_entregador: string;
  nome_cliente: string;
  tipo_venda: string;
  data_venda: string;
  data_entrega: string;
  data_previsao: string;
  atraso: string;
  tempo: string;
  obs_entrega: string;
  pago: string;
  evento: string;
  motivo: string;
  vlr_custo: number;
  vlr_entrega: number;
  vlr_troco: number;
  vlr_total: number;
  vlr_custoFormatted: string;
  vlr_entregaFormatted: string;
  vlr_trocoFormatted: string;
  vlr_totalFormatted: string;
}
interface ModalParams {
	id?: string;
	onClose: any;
	isVisible: boolean;
	entrega: EntregaData;
}

const ModalVenda: React.FC<ModalParams> = ({
  id = 'modalEntrega',
  onClose = () => {},
  isVisible,
  entrega,
}) => {
  const handleOutSideClick = useCallback(
		(e: any) => {
      if (e.target.id === id) {
				setVisible(false);
				setTimeout(() => {
					onClose();
				}, 300);
      }
    },
    [id, onClose],
  );

	function handleOnClose() {
		setVisible(false);
		setTimeout(() => {
			onClose();
		}, 200);
	};

  const [visible, setVisible] = useState(isVisible);

  return (
    <Container id="modalEntrega" onClick={handleOutSideClick}>
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
					<button onClick={handleOnClose}>
            <FiArrowLeft /> Voltar
          </button>
        </Header>

        <OrderContent>
          <Venda>
            <div className="title-venda">
              <h1>Venda</h1>

              {entrega.tipo_venda === 'IFood' ? (
                <SiIfood color="#c53030" title={entrega.tipo_venda} />
              ) : (
                <FaStore color="#1a83ff" title={entrega.tipo_venda} />
              )}
            </div>

            <h2>
              <span>Código:</span>&nbsp;{entrega.id_venda}
            </h2>
            <h2>
              <span>Data da venda:</span>&nbsp;{entrega.data_venda}
            </h2>

            <hr />
          </Venda>

          <Entrega>
            <h1>Entrega</h1>
            <h2>
              <span>Código:</span>&nbsp;{entrega.id_entrega}
            </h2>
            <h2>
              <span>Previsão:</span>&nbsp;{entrega.data_previsao}
            </h2>
            <h2>
              <span>Data Entrega:</span>&nbsp;{entrega.data_entrega}
            </h2>
            <h2>
              <span>Tempo:</span>&nbsp;{entrega.tempo}
            </h2>

            <div className="entrega-atraso">
              <h2>
                <span>Entrega:</span>&nbsp;{' '}
              </h2>
              <MdMoped color="#1a83ff" size={20} title={entrega.evento} />
              {entrega.evento !== 'Entrega' && (
                <MdMoped color="#1a83ff" size={20} />
              )}
            </div>

            <div className="entrega-atraso">
              <h2>
                <span>Atraso:</span>&nbsp;{' '}
              </h2>
              <MdTimer
                title={entrega.atraso}
                color={entrega.atraso === 'Sim' ? '#c53030' : '#1B5E20'}
                size={20}
              />
            </div>

            <div className="entrega-atraso">
              <h2>
                <span>Pago:</span>&nbsp;{' '}
              </h2>
              {entrega.pago === 'N' ? (
                <>
                  <MdMoneyOff color="#c53030" />
                </>
              ) : (
                <>
                  <MdAttachMoney color="#1B5E20" />
                </>
              )}
            </div>

            <hr />
          </Entrega>

          <Cliente>
            <h1>Cliente</h1>

            <h2>{entrega.nome_cliente || 'Sem nome'}</h2>

            <hr />
          </Cliente>

          <Entregador>
            <h1>Entregador</h1>

            <h2>{entrega.nome_entregador || 'Sem nome'}</h2>

            <hr />
          </Entregador>

          {entrega.motivo && (
            <Entregador>
              <h1>ReEntrega</h1>

              <h2>
                <span>Motivo:</span>&nbsp;
                {entrega.motivo}
              </h2>

              <hr />
            </Entregador>
          )}

          {entrega.obs_entrega !== '' && (
            <Obs>
              <h1>Observação</h1>

              <h2>{entrega.obs_entrega}</h2>

              <hr />
            </Obs>
          )}

          <Valores>
            <h1>Valores</h1>

            <div className="content-valores">
              <div className="item-valores">
                  <span>Vlr. Entrega</span>

                  <span>{entrega.vlr_entregaFormatted}</span>
              </div>

              <div className="item-valores">
                  <span>Vlr. Custo</span>

                  <span>{entrega.vlr_custoFormatted}</span>
              </div>

              <div className="item-valores">
                  <span>Vlr. Troco</span>

                  <span>{entrega.vlr_trocoFormatted}</span>
              </div>

              <div className="total-valores">
                  <span>Total</span>

                  <span>{entrega.vlr_totalFormatted}</span>
              </div>
            </div>

            <hr />
          </Valores>
        </OrderContent>
      </Content>
    </Container>
  );
};

export default ModalVenda;
